"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
require("./Tooltip.css");
var _reactPopper = require("react-popper");
function Tooltip(_ref) {
  var tooltipId = _ref.tooltipId,
    placement = _ref.placement,
    target = _ref.target,
    content = _ref.content;
  placement = placement ? placement : "right";
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    popperElement = _React$useState2[0],
    setPopperElement = _React$useState2[1];
  var _React$useState3 = _react.default.useState(null),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    arrowElement = _React$useState4[0],
    setArrowElement = _React$useState4[1];
  var _usePopper = (0, _reactPopper.usePopper)(target, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'arrow',
        options: {
          element: arrowElement
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({
    ref: setPopperElement,
    style: styles.popper,
    className: "tooltip-main bdg-tooltip-".concat(placement)
  }, attributes.popper), /*#__PURE__*/_react.default.createElement("div", {
    ref: setArrowElement,
    style: styles.arrow,
    className: 'arrow'
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: tooltipId,
    className: "tooltip-inner"
  }, content));
}
;